<template>
  <div>
    <el-form :inline="true" :model="form" size="mini" class="demo-form-inline backborder1">
      <el-form-item label="快递公司">
        <el-select v-model="form.express_id" clearable placeholder="请选择快递公司">
          <el-option v-for="item in logisticsList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="快递单号">
        <el-input v-model="form.logistics_code" clearable placeholder="请输入快递单号"></el-input>
      </el-form-item>
      <el-form-item label="销售单号">
        <el-input v-model="form.documents" clearable placeholder="请输入销售单号"></el-input>
      </el-form-item>
      <el-form-item label="回收日期">
        <el-date-picker v-model="form.timeRange" type="daterange" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width: 230px"></el-date-picker>
      </el-form-item>
      <el-form-item label="单号状态">
        <el-select v-model="form.order_status" clearable placeholder="请选择单号状态">
          <el-option label="成功" value="1"></el-option>
          <el-option label="失败" value="2"></el-option>
          <!-- 其他状态选项 -->
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList">查询</el-button>
      </el-form-item>
    </el-form>

    <div class="backborder2" style="margin-top:10px">
      <el-table :data="tableData" style="width: 100%" border size="mini">
        <el-table-column type="index" label="序号" width="80"></el-table-column>
        <el-table-column prop="logistics_name" label="快递公司"></el-table-column>
        <el-table-column prop="logistics_code" label="快递单号"></el-table-column>
        <el-table-column prop="obtain_time" label="获取快递单号时间"></el-table-column>
        <el-table-column prop="documents" label="销售单号"></el-table-column>
        <!-- <el-table-column prop="weight" label="包裹重量(kg)"></el-table-column> -->
        <el-table-column prop="is_print" label="打印状态">
          <template slot-scope="scope">
            {{ scope.row.is_print == 1 ? '已打印' : '未打印' }}
          </template>
        </el-table-column>
        <el-table-column prop="submit_recycle_time" label="提交回收时间"></el-table-column>
        <el-table-column prop="recycle_time" label="回收结果时间"></el-table-column>
        <el-table-column prop="order_status" label="单号状态">
          <template slot-scope="scope">
            <span v-if="scope.row.order_status == 1">成功</span>
            <div v-else-if="scope.row.order_status == 2">
              <div>失败</div>
              <div style="color: red;">{{ scope.row.reason }}</div>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="manager_name" label="取号操作人"></el-table-column>
      </el-table>
      <div style="display: flex;justify-content: flex-end;">
        <el-pagination @size-change="queryPageSizeChange" @current-change="queryPageCurrentChange"
          :current-page="form.p" :page-sizes="[10, 20, 30, 40]" :page-size="form.rollpage"
          layout="total, sizes, prev, pager, next, jumper" :total="form.total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: '/Sellshippingbirld/index',
      form: {
        timeRange: '', // 时间插件值
        type_record: 2,  // 记录类型，1使用记录，2回收记录
        start_time: '',
        end_time: '',
        express_id: '', // 快递公司id
        logistics_code: '', // 快递单号
        documents: '', // 销售单号
        order_status: '', // 订单状态，1成功，2失败
        p: 1,
        rollpage: 10,
        total: 0
      },
      tableData: [],
      logisticsList: []
    };
  },
  created() {
    this.getList();
    // 查询快递公司
    this.$axios({
      url: this.url,
      method: 'POST',
      data: {
        act: 'choose_express_delivery',
      }
    })
      .then(res => {
        this.logisticsList = res.Data;
      })
  },
  methods: {
    getList() {
      if (this.form.timeRange && this.form.timeRange.length) {
        this.form.start_time = this.form.timeRange[0];
        this.form.end_time = this.form.timeRange[1];
      } else {
        this.form.start_time = '';
        this.form.end_time = '';
      }
      this.$axios({
        url: this.url,
        method: 'POST',
        data: {
          act: 'generate_waybill_record',
          ...this.form
        }
      })
        .then(res => {
          this.tableData = res.Data;
          this.form.total = parseInt(res.count);
        });
    },
    queryPageSizeChange(val) {
      this.form.rollpage = val;
      this.getList();
    },
    queryPageCurrentChange(val) {
      this.form.p = val;
      this.getList();
    }
  }
};
</script>

<style scoped>
/* 添加一些样式 */
.demo-form-inline {
  margin-bottom: 20px;
}

.backborder1 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 1% 1% 0 1%
}

.backborder2 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 1% 1% 3% 1%
}
</style>


// WEBPACK FOOTER //
// src/components/home/ExpressRecycling.vue